"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashbackBoostDepositBundleAskVariant = exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_LINKED_STATUSES = exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_LIVE_STATUSES = exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_AGREED_STATUSES = exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_AWAITING_FUNDING_STATUSES = exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_UNFINISHED_STATUSES = exports.CashbackBoostDepositBundleEnrollmentStatus = void 0;
/**
 * Shared cashback boost deposit bundle enrollment, including the Home Checking opt-in.
 * Bundle membership and the committed decision are tracked per card loan application.
 * Checking opening requires accepted consent and a ready credit account; rewards require qualifying settled funding.
 */
/**
 * Lifecycle of a cashback boost deposit bundle enrollment. One meaning per status, shared by both products that use it:
 * the Rewards Card bundle and the Home Card Checking-cashback opt-in.
 * - started: the offer is presented and the customer has not decided
 * - accepted: the customer agreed to the Checking offer; Checking is not open yet
 * - pendingFunding: Checking is open and linked; the enrollment is awaiting the qualifying deposit that unlocks the boost
 * - active: the qualifying funding requirement was met and the bundle boost is live
 * - suspended: the maintained-balance requirement lapsed; reverted to the standard rewards tier
 * - declined: the customer declined the Checking offer
 * - expired: the funding window elapsed without qualifying, or the enrollment was otherwise terminated
 *
 * Historical rows can predate the decision timestamps: the status alone is not proof of when consent happened.
 */
var CashbackBoostDepositBundleEnrollmentStatus;
(function (CashbackBoostDepositBundleEnrollmentStatus) {
    CashbackBoostDepositBundleEnrollmentStatus["started"] = "started";
    CashbackBoostDepositBundleEnrollmentStatus["accepted"] = "accepted";
    CashbackBoostDepositBundleEnrollmentStatus["pendingFunding"] = "pendingFunding";
    CashbackBoostDepositBundleEnrollmentStatus["active"] = "active";
    CashbackBoostDepositBundleEnrollmentStatus["suspended"] = "suspended";
    CashbackBoostDepositBundleEnrollmentStatus["declined"] = "declined";
    CashbackBoostDepositBundleEnrollmentStatus["expired"] = "expired";
})(CashbackBoostDepositBundleEnrollmentStatus || (exports.CashbackBoostDepositBundleEnrollmentStatus = CashbackBoostDepositBundleEnrollmentStatus = {}));
/**
 * Status groups, exported next to the enum so every reader means the same set instead of re-listing statuses.
 */
/** Enrollment still has an outstanding Checking or funding step. */
exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_UNFINISHED_STATUSES = [
    CashbackBoostDepositBundleEnrollmentStatus.started,
    CashbackBoostDepositBundleEnrollmentStatus.accepted,
    CashbackBoostDepositBundleEnrollmentStatus.pendingFunding,
];
/** Agreed, but the boost is not live yet: Checking opening or qualifying funding is still outstanding. */
exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_AWAITING_FUNDING_STATUSES = [
    CashbackBoostDepositBundleEnrollmentStatus.accepted,
    CashbackBoostDepositBundleEnrollmentStatus.pendingFunding,
];
/** The customer agreed to the offer, whether or not the bundle is live. */
exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_AGREED_STATUSES = [
    CashbackBoostDepositBundleEnrollmentStatus.accepted,
    CashbackBoostDepositBundleEnrollmentStatus.pendingFunding,
    CashbackBoostDepositBundleEnrollmentStatus.active,
    CashbackBoostDepositBundleEnrollmentStatus.suspended,
    CashbackBoostDepositBundleEnrollmentStatus.expired,
];
/** Checking is open and linked, and the enrollment has not been reverted or terminated: the bundle is still live. */
exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_LIVE_STATUSES = [
    CashbackBoostDepositBundleEnrollmentStatus.pendingFunding,
    CashbackBoostDepositBundleEnrollmentStatus.active,
];
/** Checking is open and linked, including enrollments whose funding later activates or suspends the boost. */
exports.CASHBACK_BOOST_DEPOSIT_BUNDLE_LINKED_STATUSES = [
    CashbackBoostDepositBundleEnrollmentStatus.pendingFunding,
    CashbackBoostDepositBundleEnrollmentStatus.active,
    CashbackBoostDepositBundleEnrollmentStatus.suspended,
];
var CashbackBoostDepositBundleAskVariant;
(function (CashbackBoostDepositBundleAskVariant) {
    CashbackBoostDepositBundleAskVariant["openAccount"] = "openAccount";
    CashbackBoostDepositBundleAskVariant["fundAccount"] = "fundAccount";
})(CashbackBoostDepositBundleAskVariant || (exports.CashbackBoostDepositBundleAskVariant = CashbackBoostDepositBundleAskVariant = {}));
